import React from "react";
import "./AboutUs.css";
import ceoImage from "../Assets/abiola.jpg"; // Replace with your actual picture path
//Founder
const AboutUs = () => {
  return (
    <div className="about-us-container">
      <section className="about-us-intro">
        <h1>About Us</h1>
        <p>
          World Dominators Hub Media & Technology Limited is not just another media or tech company — we are the command center for creators, innovators, and visionaries who refuse to play small. We exist to dominate the intersection of media, technology, and human potential. From the very first line of our Memorandum of Association, our mission has been clear: build powerful platforms, create world-class content, develop cutting-edge technology, and raise an army of technological geniuses who are ready to conquer industries.
        </p>
        <h2>What We Stand For</h2>
        <ul>
          <li>We don’t follow trends — we set them.</li>
          <li>We don’t just produce content — we engineer influence.</li>
          <li>We don’t just train people — we forge dominators.</li>
        </ul>
        <h2>At World Dominators Hub, you will find:</h2>
        <ul>
          <li>Premium Media Content & Templates — High-converting visuals, videos, Reels, and storytelling assets.</li>
          <li>Technology Products & Solutions — Custom software, mobile apps, websites, and innovative engineering tools.</li>
          <li>World-Class Training & Mentorship — Programs that turn ambitious minds into elite media creators and digital leaders.</li>
          <li>Expert Hiring Marketplace — Access to vetted media and technology professionals.</li>
        </ul>
        <h2>Our Purpose</h2>
        <p>
          Our soul’s purpose is simple yet powerful: to create spaces where ordinary people become unstoppable. We believe the future belongs to those who control their narrative, master technology, and build with intention.
        </p>
        <h2>Why Creators & Brands Choose Us</h2>
        <p>
          Because we don’t just deliver — we dominate alongside you. Whether you are a startup founder, scaling your business, or an individual leveling up your skills, World Dominators Hub gives you the tools, the talent, and the tribe to win.
        </p>
      </section>

      {/* CEO Section */}
      <section className="ceo-section">
        {/* <img src={ceoImage} alt="Eric Howard Dobuler" className="ceo-photo" /> */}
        <div className="ceo-details">
          <h2>Eric Howard Dobuler</h2>
          <p>CEO / Director</p>
          <p>
            <strong>Address:</strong>1 Borcher Ave, Yonkers, NY 10704
          </p>
          <p>
            <strong>Instagram:</strong> <a href="https://www.instagram.com/wdhmedia.tec" target="_blank" rel="noopener noreferrer">@wdhmedia.tec</a>
          </p>
          <p>
            <strong>Phone:</strong> <a href="tel:+1805475-3211">+1 (805) 475-3211 OR +1 (914) 691-6155</a>
          </p>
          <p>
            <strong>Email:</strong> <a href="mailto:ericdobulertwin26@gmail.com">ericdobulertwin26@gmail.com</a>
          </p>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;